import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteField from 'components/list/Filters/types/autocomplete/AutoCompleteField';
import compose from 'recompose/compose';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { fetchSubcategories } from 'store/actions/subcategories/fetchSubcategories';
import utils from 'helpers/utils';

class RenderSubCategoriesInputField extends React.Component {
    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        const { categoryId } = this.props;

        if (prevProps.categoryId !== categoryId) {
            this.fetchData();
        }
    }

    fetchData() {
        const { categoryId, fetchSubcategories } = this.props;

        let params = {
            size: 96,
            offset: 0,
            sort: {
                field: 'name',
                order: 'asc',
            },
        };

        if (categoryId) {
            params.category_id = categoryId;
        }

        // Fetch all the available subcategories.
        fetchSubcategories(params);
    }

    handleInputUpdate = utils.debounce((searchText, dataSource, params) => {
        // If the string of the source is not 'change' it will not continue.
        if (params.source !== 'change') {
            return;
        }

        // Remove whitespaces around the text.
        if (utils.isString(searchText)) {
            searchText.trim();
        }

        // Check if the searchText already exists in the dataSource.
        const textExists = dataSource.filter(function (data) {
            return data.text === searchText;
        });

        // If the length of the array > 0, it will not continue.
        if (textExists.length) {
            return;
        }
    }, 500);

    render() {
        const {
            choices,
            input,
            label,
        } = this.props;

        return (
            <Field
                component={ AutoCompleteField }
                choices={ choices }
                floatingLabelFixed={ false }
                fullWidth={ true }
                input={ input }
                onInputUpdate={ this.handleInputUpdate }
                label={ label ? label : null }
                name={ input.name }
                optionText='name'
                optionValue='id'
            />
        );
    }
}

RenderSubCategoriesInputField.propTypes = {
    choices: PropTypes.array,
    fetchSubcategories: PropTypes.func.isRequired,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
    categoryId: PropTypes.number,
};

/**
 * @param {Object} obj - Object of subcategories
 * @param {number} identifier - defines the categoryID on which needs to be filtered.
 *
 * @returns {Array}
 */
const getListFilterByCategoryId = (obj, identifier) => {
    const key = 'category_id';
    let arr = [];

    utils.each(obj, (value) => {
        if (value[key] === identifier) {
            arr.push(value);
        }
    });

    return arr;
};

const mapStateToProps = (state, props) => {
    const { categoryId } = props;
    let choices = Object.values(state.subcategories.data);

    // If the category has not been set, we will show the full list.
    if (categoryId) {
        choices = getListFilterByCategoryId(choices, categoryId);
    }

    return {
        choices: choices,
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        {
            fetchSubcategories: fetchSubcategories,
        }
    )
);

export default enhance(RenderSubCategoriesInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/AutoCompleteField/RenderSubCategoriesInputField.js